import React from "react"
import Text from "@/components/common/Text"

const DoubleColumnDescription = ({ desc, desc2, color }) => {
	return (
		<>
			<Text tag="div" className="typo-borna typo-borna-11 description" color={color} dangerouslySetInnerHTML={desc} />
			<Text tag="div" className="typo-borna typo-borna-11 description" color={color} dangerouslySetInnerHTML={desc2} />
		</>
	)
}

export default DoubleColumnDescription
